import React, { useEffect, useState } from 'react'
import { Dropdown } from 'primereact/dropdown'
import { getCentraisOperacoes } from '../../services/localstorage/localstorage.service'

const styles = {
  label: {
    display: 'block',
    color: '#14B0BF',
    marginBottom: 5,
    fontSize: '0.8rem',
  },
}

function CentraisOperacaoDropdown({ value, onChange, showLabel = false }) {
  const [centrais, setCentrais] = useState(null)

  useEffect(() => {
    const centraisStorage = getCentraisOperacoes()

    const centraisMapped = centraisStorage
      ? centraisStorage.map(central => {
          return {
            label: central.name,
            value: central.id,
          }
        })
      : null

    setCentrais(centraisMapped)
    onChange(value ? value : centraisMapped[0].value)
  }, [])

  // Render
  return (
    <React.Fragment>
      {showLabel ? <label style={styles.label}>Centrais de Operação :</label> : null}
      <Dropdown
        style={{ width: '100%' }}
        value={value}
        options={centrais}
        onChange={e => onChange(e.value)}
        placeholder="Centrais de Operações"
        filter
      />
    </React.Fragment>
  )
}

export default CentraisOperacaoDropdown
